import jsPDF from "jspdf";
import logo1 from "../../images/partnersLogo/1.png";
import logo2 from "../../images/partnersLogo/2.png";
import logo3 from "../../images/partnersLogo/3.png";
import logo4 from "../../images/partnersLogo/4.png";
import logo5 from "../../images/partnersLogo/5.png";
import logo6 from "../../images/partnersLogo/6.png";
import logo7 from "../../images/partnersLogo/7.png";
import ChallanPrint from "./ChallanPrint";

function StandardTwo({
  billNumber = "",
  customer = "",
  items = "",
  discount = "",
  discountType = "",
  discount_text = "",
  date = "",
  subTotal = "",
  Total = "",
  paid = "",
  formallyOutstandings = "0",
  argSell = "",
  ledger_id = "",
  notes = "",
  quotation = "false",
  varTotal
}) {
  let doc = new jsPDF();
  let pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
   const companyCode = localStorage.getItem("company");
  let img1 = new Image();
  let img2 = new Image();
  let img3 = new Image();
  let img4 = new Image();
  let img5 = new Image();
  let img6 = new Image();
  let img7 = new Image();

  img1.src = logo1;
  img2.src = logo2;
  img3.src = logo3;
  img4.src = logo4;
  img5.src = logo5;
  img6.src = logo6;
  img7.src = logo7;

  doc.setFontSize(26);
  doc.setFontStyle("bold");
  doc.text(localStorage.getItem("company"), pageWidth / 2, 15, {
    align: "center",
  });
  doc.setFontSize(18);
  doc.setFontStyle("normal");

  doc.text(localStorage.getItem("address"), pageWidth / 2, 25, {
    align: "center",
  });
    doc.text(localStorage.getItem("phone") || "", pageWidth / 2, 33, {
      align: "center",
    });
  if (quotation == true) {
    doc.text("Quotation", pageWidth / 2, 40, {
      align: "center",
    });
  }

  doc.setFontSize(18);
  doc.setFontStyle("bold");
  doc.text("Customer", 10, 58);
  doc.setFontSize(14);
  doc.setFontStyle("normal");
  doc.text(customer, 10, 68);

  // if (ledger_id !== "new" || new_ledger.name) {
  //   doc.setFontSize(18);
  //   doc.setFontStyle("bold");
  //   doc.text(printType == "Urdu" ? "کسٹمر" : "Ledger", 70, 58);
  //   doc.setFontStyle("normal");
  //   doc.setFontSize(14);
  //   if (ledger_id !== "new") {
  //     doc.text(JSON.parse(idString)?.name, 70, 68);
  //   } else {
  //     doc.text(new_ledger.name, 70, 68);
  //   }

  //   doc.setFontSize(18);
  //   doc.setFontStyle("bold");
  //   doc.text(printType == "Urdu" ? "بقایا" : "Balance", 70, 78);
  //   doc.setFontStyle("normal");
  //   doc.setFontSize(14);
  //   if (ledger_id !== "new") {
  //     if (JSON.parse(idString).saleTotal) {
  //       doc.text(JSON.parse(idString)?.saleTotal.toString(), 70, 88);
  //     } else {
  //       doc.text("0", 70, 88);
  //     }
  //   } else {
  //     doc.text((Total - paid).toString(), 70, 88);
  //   }
  // }

  doc.setFontSize(20);
  doc.setFontStyle("bold");
  doc.text("Bill Detail", 130, 58);

  doc.setFontSize(14);
  doc.setFontStyle("normal");
  doc.text("Date : ", 130, 68);
  doc.text(date, 165, 68);

  doc.text("Bill No. : ", 130, 75);
  doc.text(billNumber.toString(), 168, 75);
  jsPDF.autoTableSetDefaults({
    headStyles: { fillColor: "#4daf51", font: "Amiri" },
    margin: { left: 8, right: 8, bottom: 10 },
    bodyStyles: { font: "Amiri" },
  });
  var col = ["#", "Description", "Qty", "Price", "Discount", "Total Price"];
  var rows = [];

  items &&
    items.forEach((item, index) => {
      let itemPrice = item.salePrice ? item.salePrice : item.price;
      let finalPrice = parseInt(itemPrice * item.saleQuantity);
      let totalDiscount;
      let itemDiscount;

      if (item.saleDiscount) {
        itemDiscount = item.saleDiscount;
        let eachValue = (item.saleDiscount / 100) * finalPrice;
        totalDiscount = eachValue;
      } else {
        if (item.discount) {
          itemDiscount = item.discount;
          let eachValue = (item.discount / 100) * finalPrice;
          totalDiscount = eachValue;
        } else {
          itemDiscount = 0;
          totalDiscount = 0;
        }
      }
      doc.setFontSize(14);

      let temp = [
        index + 1,
        item.description,
        item.unit ? item.saleQuantity + " " + item.unit : item.saleQuantity,
        itemPrice,
        itemDiscount + "%",
        finalPrice - totalDiscount,
      ];
      rows.push(temp);
    });

  doc.autoTable(col, rows, { startY: 100 });

  let finalY = doc.lastAutoTable.finalY;

  doc.setFontSize(14);
  doc.setFontStyle("normal");
  doc.text("Sub Total", 120, finalY + 13);
  doc.text("Discount", 120, finalY + 20);
  if(companyCode == "3388") {
    doc.text("Var Total", 130, finalY + 23);

  }
  doc.text("Previous Balance", 120, finalY + 27);
  doc.text("Total", 120, finalY + 33);
  doc.text("Paid", 120, finalY + 41);
  doc.text("Balance", 120, finalY + 48);

  // let unts = discountType == "percentage" ? "%" : "Rps";
  let unts = companyCode == "3388" ? 
  "AED" : 
  ( discountType == "percentage" ? "%" : "Rps");

  doc.text(Total.toString(), 168, finalY + 13);
  let discs = discountType == "percentage" ? discount_text : discount;
  doc.text(discs.toString() + " " + unts, 168, finalY + 20);
  if(companyCode == "3388") {
    doc.text((varTotal ?? 0).toString(), 168, finalY + 27);

  }
 const positionY = companyCode ==  "3388" ? finalY + 33 : finalY +27;
  doc.text(formallyOutstandings.toString(), 168, positionY );
  let final_tots =
    Total > 0 ? Total : Total - discount + parseInt(formallyOutstandings);
    const positionYFinalTotal = companyCode ==  "3388" ? finalY + 39 : finalY +33;

  doc.text(final_tots.toString(), 168, positionYFinalTotal);
  const positionYFinalPaid = companyCode ==  "3388" ? finalY + 47 : finalY +39;

  doc.text(paid.toString(), 168, positionYFinalPaid);
  const positionYFinalPosition = companyCode ==  "3388" ? finalY + 55 : finalY +47;

  doc.text(
    (parseInt(final_tots) - parseInt(paid)).toString(),
    168,
    positionYFinalPosition 
  );

  doc.addImage(img1, "png", 40, 270, 15, 15);
  doc.addImage(img2, "png", 58, 270, 15, 15);
  doc.addImage(img3, "png", 76, 270, 15, 15);
  doc.addImage(img4, "png", 94, 270, 15, 15);
  doc.addImage(img5, "png", 112, 270, 15, 15);
  doc.addImage(img6, "png", 130, 270, 15, 15);
  doc.addImage(img7, "png", 148, 270, 15, 15);

  doc.setFontSize(10);
  let temp = localStorage.getItem("template");
  if (temp == "standardTwo") {
    if (window.innerWidth <= 600) {
      doc.save("reciept");
    } else {
      doc.autoPrint();
      window.open(doc.output("bloburl"), "_blank");
    }
  } else if (temp == "standardTwoDeliveryChallan") {
    doc.addPage();
    ChallanPrint(billNumber, customer, items, date, quotation, doc);
  }
}

export default StandardTwo;
